import { render } from "./PendingShipment.vue?vue&type=template&id=77e8b0c2"
import script from "./PendingShipment.vue?vue&type=script&lang=js"
export * from "./PendingShipment.vue?vue&type=script&lang=js"

import exportComponent from "/Users/macmini/Sites/self-ship/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__